import { NotificationsApi } from "@virtualprogaming/js-public-sdk";
import { useMemo } from "react";

import { useApiConfig } from "~/utils";

export function useNotificationsApi() {
  const config = useApiConfig();
  return useMemo(() => new NotificationsApi(...config), [config]);
}
